import type React from 'react';

export const isInteractiveElement = (element: HTMLElement | null, container?: HTMLElement | null): boolean => {
  if (!element) {
    return false;
  }

  const interactive = element.closest(
    'button, a, input, textarea, select, [role="button"], [contenteditable="true"], [data-stop-propagation="true"]',
  );

  if (!interactive) {
    return false;
  }

  if (container && interactive === container) {
    return false;
  }

  return true;
};

export const activateWithKeyboard = (event: React.KeyboardEvent, action: () => void): void => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    action();
  }
};
